import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-right\">\n<path d=\"M6.75008 14.0625C6.60758 14.0625 6.46508 14.01 6.35258 13.8975C6.13508 13.68 6.13508 13.32 6.35258 13.1025L10.4551 8.99996L6.35258 4.89746C6.13508 4.67996 6.13508 4.31996 6.35258 4.10246C6.57008 3.88496 6.93008 3.88496 7.14758 4.10246L11.6476 8.60246C11.8651 8.81996 11.8651 9.17996 11.6476 9.39746L7.14758 13.8975C7.03508 14.01 6.89258 14.0625 6.75008 14.0625Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol